import * as types from "../actions/actionTypes";
import initialState from "./initialState";
import { LocalizationsActions } from "../actions/localizationsActions";
import { MentorLocalizations } from "../../../Shared/sharedTypes";

export default function localizationsReducer(
    state = initialState.localizations,
    action: LocalizationsActions
): MentorLocalizations | null {
    switch (action.type) {
        case types.LOAD_LOCALIZATIONS_SUCCESS:
            return action.localizations;
        default:
            return state;
    }
}
